import { get } from "../../utils/objectHelpers";

$ {
    const main = get(input, 'regionsData.MAIN', []);
    const tab1 = get(input, 'regionsData.TAB1', []);
    const spinnerModule = main.find(m => m.meta && m.meta.name === 'LOADING_SPINNER');
    const storePolicies = tab1.find(m => m.meta && m.meta.name === 'ABOUT_STORE_POLICIES');
    const title = get(storePolicies, "title", {});
}

<if(state.sections.length)>
    <div class="str-about-policies about-layout--gutters">
        <h2 class="str-about-policies__title large-product-title section-header">
            <str-textual-display ...title />
        </h2>
        <for|section, idx| of=state.sections>
            $ {
                const type = get(section, 'action.params.policyTypes', '');
                const policy = state.policies[type];
            }
            <ebay-details on-toggle("fetchPolicies")
                open=section.isOpen
                text=section.title.textSpans[0].text
                as="div"
                key=idx>

                <input type="hidden" class="policy-type" value=type />
                <if(policy)>
                    $!{policy}
                </if>
                <else>
                    <str-loading-spinner ...spinnerModule
                        size="small"
                        isShow="true"/> 
                </else>
            </ebay-details>
        </for>
    </div>
</if>
